import { render, staticRenderFns } from "./SlidePanel.vue?vue&type=template&id=fba2510e&scoped=true&"
import script from "./SlidePanel.vue?vue&type=script&lang=js&"
export * from "./SlidePanel.vue?vue&type=script&lang=js&"
import style0 from "./SlidePanel.vue?vue&type=style&index=0&id=fba2510e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba2510e",
  null
  
)

export default component.exports